import { Section } from './Section';
import './StickySection.scss';
class StickySectionStack {
    sections;
    baseZIndex;
    constructor() {
        this.sections = [];
        this.baseZIndex = 5;
    }
    add(section) {
        this.sections.push(section);
        // Order the sections by the order in the DOM.
        this.sections.sort((a, b) => {
            return a.initialTop - b.initialTop;
        });
        this.update();
    }
    remove(section) {
        this.sections = this.sections.filter((s) => s !== section);
        this.update();
    }
    update() {
        let accumulatedHeight = 0;
        let zIndex = this.baseZIndex;
        this.sections.forEach((section) => {
            section.update({
                top: accumulatedHeight,
                zIndex,
            });
            accumulatedHeight += section.offsetHeight;
            // This makes sure that sections animate behind each other instead of over of each other.
            zIndex--;
        });
    }
}
export class StickySection extends Section {
    static stack = new StickySectionStack();
    initialTop;
    currentSticky;
    currentScrollTop;
    constructor(name) {
        super(name);
        this.validateProps(['sectionId', 'sticky']);
        this.initialTop = this.getBoundingClientRect().top;
        this.currentSticky = false;
        this.currentScrollTop = window.scrollY;
    }
    componentDidMount() {
        this.init();
        const resizeObserver = new ResizeObserver(() => {
            this.init();
            StickySection.stack.update();
        });
        resizeObserver.observe(this);
        switch (this.props.sticky) {
            case 'always': {
                this.currentSticky = true;
                StickySection.stack.add(this);
                this.classList.add('Sticky');
                break;
            }
            case 'on_scroll_up':
                this.classList.add('Sticky');
                this.classList.add('Sticky--Hidden');
                // TODO: Check if we need to debounce this.
                window.addEventListener('scroll', this.handleScroll.bind(this));
                break;
        }
    }
    handleScroll() {
        const scrollTop = window.scrollY;
        if (scrollTop <= this.currentScrollTop) {
            if (!this.currentSticky) {
                this.currentSticky = true;
                this.classList.remove('Sticky--Hidden');
                StickySection.stack.add(this);
            }
        }
        else {
            this.currentSticky = false;
            this.classList.add('Sticky--Hidden');
            StickySection.stack.remove(this);
        }
        this.currentScrollTop = scrollTop;
    }
    init() {
        this.sectionElement.style.setProperty('--height', `${this.offsetHeight}px`);
    }
    update(styles) {
        this.sectionElement.style.setProperty('--top', `${styles.top}px`);
        this.sectionElement.style.setProperty('--z-index', `${styles.zIndex}`);
    }
    get sectionElement() {
        const sectionElement = this.closest(`#shopify-section-${this.props.sectionId}`);
        if (!(sectionElement instanceof HTMLElement)) {
            throw new Error(`Section with id ${this.props.sectionId} not found`);
        }
        return sectionElement;
    }
}
